import(/* webpackMode: "eager", webpackExports: ["LandingHeader"] */ "/home/runner/work/mdsite4/mdsite4/app/_components/landing-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/runner/work/mdsite4/mdsite4/app/_components/sections.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mdsite4/mdsite4/app/landing.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/mdsite4/mdsite4/app/skills/query/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorks"] */ "/home/runner/work/mdsite4/mdsite4/app/skills/query/how-it-works.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuerySkillExplained"] */ "/home/runner/work/mdsite4/mdsite4/app/skills/query/query-skill-explained.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RealWorldDemos"] */ "/home/runner/work/mdsite4/mdsite4/app/skills/query/real-world-demos.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mdsite4/mdsite4/app/skills/skills-landing.css");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/home/runner/work/mdsite4/mdsite4/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/home/runner/work/mdsite4/mdsite4/components/ui/separator.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mdsite4/mdsite4/node_modules/.pnpm/next@15.5.10_@babel+core@7.28.3_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_react-dom@19_rsxbpatvq2qagx3m4vyis2rtqy/node_modules/next/dist/client/app-dir/link.js");
